import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SatPopoverModule } from '@ncstate/sat-popover'
import { TranslateModule } from '@ngx-translate/core'
import { QuillModule } from 'ngx-quill'
import { NgxStripeModule } from 'ngx-stripe'

import { environment } from '../../../../environments'
import {
  IsDirtyService,
  NavigationService,
  ProgressIndicatorService,
  SelectedRecordFacilitatorService,
  SvgIconsService,
} from '../services'

/**
 * The SharedModule is where any extremely common components, pipes/filters, and non-singleton services should go.
 * The SharedModule can be imported in any other module when those items will be re-used.
 * The SharedModule shouldn’t have any dependency to the rest of the application and should therefore not rely on any other module.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    NgxStripeModule.forRoot(environment.stripePublicKey),
    QuillModule.forRoot(),
    RouterModule,
    SatPopoverModule,
    TranslateModule,
  ],
  providers: [
    IsDirtyService,
    NavigationService,
    ProgressIndicatorService,
    SelectedRecordFacilitatorService,
    SvgIconsService,
  ],
  exports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    NgxStripeModule,
    RouterModule,
    TranslateModule,
  ],
})
export class SharedModule {}
